"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.stripeOnload = exports.initStripe = void 0;
const checkout_frontend_library_1 = require("@bold-commerce/checkout-frontend-library");
const src_1 = require("..");
function initStripe(payment) {
    return __awaiter(this, void 0, void 0, function* () {
        const src = 'https://js.stripe.com/v3/';
        const onLoad = () => __awaiter(this, void 0, void 0, function* () { return yield stripeOnload(payment); });
        yield (0, src_1.loadJS)(src, onLoad);
    });
}
exports.initStripe = initStripe;
function stripeOnload(payment) {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        const currency = (0, checkout_frontend_library_1.getCurrency)();
        const { order_total } = (0, checkout_frontend_library_1.getApplicationState)();
        const { general_settings } = (0, checkout_frontend_library_1.getOrderInitialData)();
        const country = payment.account_country;
        const displayItems = (0, src_1.getPaymentRequestDisplayItems)();
        const stripeInstance = window['Stripe'](payment.key, { stripeAccount: payment.stripe_user_id });
        const paymentRequest = stripeInstance.paymentRequest({
            currency: currency.iso_code.toLowerCase(),
            country: country,
            total: {
                label: 'Total',
                amount: order_total,
            },
            requestShipping: true,
            requestPayerName: true,
            requestPayerEmail: true,
            requestPayerPhone: general_settings.checkout_process.phone_number_required,
            displayItems: displayItems
        });
        const elements = stripeInstance.elements();
        const stripeButton = elements.create('paymentRequestButton', {
            paymentRequest: paymentRequest,
            style: {
                paymentRequestButton: {
                    type: 'default',
                    theme: 'dark',
                },
            },
        });
        // creating a stripe payment div inside express payment container
        const stripeDiv = document.createElement('div');
        stripeDiv.id = 'stripe-express-payment';
        stripeDiv.className = 'stripe-express-payment express-payment';
        (_a = document.getElementById('express-payment-container')) === null || _a === void 0 ? void 0 : _a.appendChild(stripeDiv);
        const result = yield paymentRequest.canMakePayment();
        if (result) {
            stripeButton.mount('#stripe-express-payment');
            (0, src_1.enableDisableSection)(src_1.showPaymentMethodTypes.STRIPE, true);
        }
        else {
            stripeDiv.style.display = 'none';
        }
        paymentRequest.addEventListener('shippingaddresschange', (event) => __awaiter(this, void 0, void 0, function* () {
            yield (0, src_1.checkStripeAddress)(event);
        }), false);
        paymentRequest.addEventListener('shippingoptionchange', (event) => __awaiter(this, void 0, void 0, function* () {
            yield (0, src_1.changeStripeShippingLines)(event);
        }), false);
        paymentRequest.addEventListener('token', (event) => __awaiter(this, void 0, void 0, function* () {
            return new Promise(function (resolve, reject) {
                (0, src_1.addStripePayment)(event, payment.public_id).then(resolve, reject);
                setTimeout(reject, 29999);
            });
        }), false);
    });
}
exports.stripeOnload = stripeOnload;
